
const initialState = {
  activeAvailability: null,
  data: [],
}

export default function availabilitiesReducer (state = initialState, action) {
  switch (action.type) {
    case 'SET_AVAILABILITIES':
      return {
        ...state,
        data: action.payload,
      };
    case 'SET_ACTIVE_AVAILABILITY':
      return {
        ...state,
        activeAvailability: action.payload.availId,
      };
    default:
      return state;
  }
};